export const sendToHubspot = route => {
  var _hsq = (window._hsq = window._hsq || [])
  _hsq.push(['setPath', route])
  _hsq.push(['trackPageView'])
}
